export const ROUTES = [
    {
        href: "/index.html",
        label: "Inicio"
    },
    {
        href: "/pages/about.html",
        label: "Acerca de"
    },
    {
        href: "/pages/contact.html",
        label: "Contacto"
    }
]

export const PROTECTED_ROUTES = [
    {
        href: "/pages/dashboard",
        label: "Dashboard"
    },
]